define(function (require) {
    "use strict";

    var LE = require("app");
    var SpecialOccasionEventModel = require("models/entities/scheduling/SpecialOccasionEventModel");
    var DateUtility = require("utils/DateUtility");
    var Validator = require("utils/ValidationUtilities");
    var ScheduleUtilities = require("utils/ScheduleUtilities");

    var NAME = "SpecialOccasionEventsCollection";

    var SpecialOccasionEventsCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionEventsCollection = Backbone.Collection.extend({
            name: NAME,
            model : SpecialOccasionEventModel,

            comparator: function(model) {
                var endDate = model.getEndDate();
                var startDate = model.getStartDate();
                var endDateAsString = !_.isNull(endDate) ? endDate.getTime() : DateUtility.strToDateObj('3000-1-1').getTime();
                var startDateAsString = !_.isNull(startDate) ? startDate.getTime() : DateUtility.strToDateObj('1970-1-1').getTime();

                return [startDateAsString, endDateAsString];
            },

            validate : function () {
                var errors = {};

                this.setDuplicates();

                this.each(function(specialOccasionEventModel) {
                    var modelErrors = specialOccasionEventModel.validate();
                    if (modelErrors) {
                        errors[specialOccasionEventModel.id] = modelErrors;
                    }
                });

                return errors;
            },

            setDuplicates: function() {
                // clean up
                _.each(this.models, function(model) {
                    model.errors.withinListDuplicated = false;
                });

                // find duplicates
                var duplicatedItems = Validator.findDuplicationsInCollection(this,
                    function(model1, model2){
                        return !model1.isNew() && !model2.isNew() &&
                            model1.getName() === model2.getName() &&
                            DateUtility.timeObjectToSte(model1.getStartDate()) === DateUtility.timeObjectToSte(model2.getStartDate()) &&
                            DateUtility.timeObjectToSte(model1.getEndDate()) === DateUtility.timeObjectToSte(model2.getEndDate());
                    });

                // mark them
                _.each(duplicatedItems, function(duplicatedModel) {
                    duplicatedModel.errors.withinListDuplicated = true;
                });
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionEventsCollection;
});
